(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6465],{

/***/ 87933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(59499);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50029);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92495);
/* harmony import */ var _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11267);
/* harmony import */ var _api_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38584);
/* harmony import */ var _api_redux_research__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83473);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var _components_innerbanner_v9__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8711);
/* harmony import */ var _components_research_ResearchList__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74836);
/* harmony import */ var _components_home_Newsletter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87820);
/* harmony import */ var _components_Quotes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77791);
/* harmony import */ var _components_CTA_v3__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69589);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68777);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(68312);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);






















var Research = function Research(_ref) {
  var _getPost$posts, _getPost$posts$data, _getPost$posts2, _getPost$posts2$data, _getPost$posts2$data$, _getPost$posts3, _getPost$posts3$data, _getPost$posts3$data$, _getPost$posts4, _getPost$posts4$data, _getPost$posts4$data$, _getPost$posts5, _getPost$posts5$data, _getPost$posts5$data$, _banner$section_data, _banner$images, _banner$images$list, _banner$images$list$;

  var offset = _ref.offset,
      winWidth = _ref.winWidth;
  var getPost = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function (state) {
    return state.researchReducer;
  });
  var page_data = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts = getPost.posts) === null || _getPost$posts === void 0 ? void 0 : (_getPost$posts$data = _getPost$posts.data) === null || _getPost$posts$data === void 0 ? void 0 : _getPost$posts$data.page_data;
  var banner = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts2 = getPost.posts) === null || _getPost$posts2 === void 0 ? void 0 : (_getPost$posts2$data = _getPost$posts2.data) === null || _getPost$posts2$data === void 0 ? void 0 : (_getPost$posts2$data$ = _getPost$posts2$data.sections) === null || _getPost$posts2$data$ === void 0 ? void 0 : _getPost$posts2$data$.find(function (f) {
    var _f$section_data;

    return (f === null || f === void 0 ? void 0 : (_f$section_data = f.section_data) === null || _f$section_data === void 0 ? void 0 : _f$section_data.slug) === 'research-banner';
  });
  var newsletter = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts3 = getPost.posts) === null || _getPost$posts3 === void 0 ? void 0 : (_getPost$posts3$data = _getPost$posts3.data) === null || _getPost$posts3$data === void 0 ? void 0 : (_getPost$posts3$data$ = _getPost$posts3$data.sections) === null || _getPost$posts3$data$ === void 0 ? void 0 : _getPost$posts3$data$.find(function (f) {
    var _f$section_data2;

    return (f === null || f === void 0 ? void 0 : (_f$section_data2 = f.section_data) === null || _f$section_data2 === void 0 ? void 0 : _f$section_data2.slug) === 'research-newsleter';
  });
  var quotes = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts4 = getPost.posts) === null || _getPost$posts4 === void 0 ? void 0 : (_getPost$posts4$data = _getPost$posts4.data) === null || _getPost$posts4$data === void 0 ? void 0 : (_getPost$posts4$data$ = _getPost$posts4$data.sections) === null || _getPost$posts4$data$ === void 0 ? void 0 : _getPost$posts4$data$.find(function (f) {
    var _f$section_data3;

    return (f === null || f === void 0 ? void 0 : (_f$section_data3 = f.section_data) === null || _f$section_data3 === void 0 ? void 0 : _f$section_data3.slug) === 'research-quotes';
  });
  var cta = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts5 = getPost.posts) === null || _getPost$posts5 === void 0 ? void 0 : (_getPost$posts5$data = _getPost$posts5.data) === null || _getPost$posts5$data === void 0 ? void 0 : (_getPost$posts5$data$ = _getPost$posts5$data.sections) === null || _getPost$posts5$data$ === void 0 ? void 0 : _getPost$posts5$data$.find(function (f) {
    var _f$section_data4;

    return (f === null || f === void 0 ? void 0 : (_f$section_data4 = f.section_data) === null || _f$section_data4 === void 0 ? void 0 : _f$section_data4.slug) === 'research-cta';
  });
  var elementRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_13__.useRouter)();
  var currentUrl = router && router.asPath;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
      title: "".concat(page_data !== null && page_data !== void 0 && page_data.title ? (page_data === null || page_data === void 0 ? void 0 : page_data.title) + ' | Shanta Securities Limited' : 'Shanta Securities Limited'),
      description: page_data === null || page_data === void 0 ? void 0 : page_data.meta_description,
      canonical: "https://www.shantasecurities.com" + currentUrl,
      openGraph: {
        type: 'website',
        url: "https://www.shantasecurities.com" + currentUrl,
        title: page_data === null || page_data === void 0 ? void 0 : page_data.og_title,
        description: page_data === null || page_data === void 0 ? void 0 : page_data.og_description,
        images: [{
          url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }, {
          url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }]
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(StyledComponent, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("div", {
        ref: elementRef,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_innerbanner_v9__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          title: page_data === null || page_data === void 0 ? void 0 : page_data.title,
          text: banner === null || banner === void 0 ? void 0 : (_banner$section_data = banner.section_data) === null || _banner$section_data === void 0 ? void 0 : _banner$section_data.short_desc,
          src: banner === null || banner === void 0 ? void 0 : (_banner$images = banner.images) === null || _banner$images === void 0 ? void 0 : (_banner$images$list = _banner$images.list) === null || _banner$images$list === void 0 ? void 0 : (_banner$images$list$ = _banner$images$list[0]) === null || _banner$images$list$ === void 0 ? void 0 : _banner$images$list$.full_path
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("div", {
          className: "research-page",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_research_ResearchList__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            data: getPost === null || getPost === void 0 ? void 0 : getPost.posts
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_home_Newsletter__WEBPACK_IMPORTED_MODULE_10__["default"], {
          no: true,
          data: newsletter
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_Quotes__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          no: true,
          data: quotes,
          background: '#F8F8F8'
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_CTA_v3__WEBPACK_IMPORTED_MODULE_12__["default"], {
          no: true,
          data: cta,
          winWidth: winWidth,
          offset: offset
        })]
      })
    })]
  });
};

var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "research__StyledComponent",
  componentId: "sc-1cpeo5-0"
})(["h3{font-size:28px;line-height:42px;font-weight:600;color:", ";}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__/* .text */ .fL);
Research.getInitialProps = _api_store__WEBPACK_IMPORTED_MODULE_5__/* .wrapper.getInitialPageProps */ .YS.getInitialPageProps(function (store) {
  return /*#__PURE__*/(0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)( /*#__PURE__*/_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _param;

    var api_services, param;
    return _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api_services = _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_3__/* .ApiServices.SECTIONS */ .u.SECTIONS;
            param = (_param = {}, (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.TYPE */ .j.TYPE, 'slug'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.VALUE */ .j.VALUE, 'research-center'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.GET_SECTION */ .j.GET_SECTION, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.IMAGE */ .j.IMAGE, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.POST */ .j.POST, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.GALLERY */ .j.GALLERY, 'yes'), _param);
            _context.next = 4;
            return store.dispatch((0,_api_redux_research__WEBPACK_IMPORTED_MODULE_6__/* .fetchPosts */ .T6)([api_services, param]));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
});
/* harmony default export */ __webpack_exports__["default"] = (Research);

/***/ }),

/***/ 48604:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research",
      function () {
        return __webpack_require__(87933);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,7724,7006,7118,7580,1850,2768,8456,9774,2888,179], function() { return __webpack_exec__(48604); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);